module.exports = {
    label: {
        registertitle: 'Registre-se para obter uma instalação grátis do ChurchTools',
        churchname: 'Nome completo da sua igreja',
        city: 'Cidade',
        countrycode: 'País',
        instancename: {
            short: 'Endereço da sua instalação do ChurchTools',
            long: 'Endereço para acesso a sua instalação do ChurchTools'
        },
        yoururl: 'Sua URL do ChurchTools: ',
        baselanguage: {
            short: 'Idioma',
            long:
                'Idioma em que o banco de dados do seu ChurchTools será instalado. Posteriormente será possível selecionar outros idiomas para uso. '
        },
        contactperson: 'Nos conte um pouco sobre você',
        contactpersonDenomination: 'Sobre o administrador',
        churchinformation: 'Nos conte um pouco sobre sua igreja',
        churchinformationDenomination: 'About the church',
        optionalInformation: 'Outras informações',
        name: 'Nome',
        firstname: 'Nome',
        lastname: 'Sobrenome',
        email: 'E-mail',
        phone: 'Telefone caso tenhamos perguntas',
        discountcode: 'Código de desconto',
        comments: 'Outros comentários',
        checkagbs: 'Eu li e aceito os termos do {link}.',
        checkgdpr: 'Eu li a {link}.',
        checknewsletter:
            'Gostaria de receber o boletim informativo mensal com dicas e notícias do ChurchTools. Estou ciente de que posso revogar meu consentimento a qualquer momento, com efeito para o futuro. Observação: Há um link de cancelamento de assinatura em cada boletim informativo.',
        checknewsletterDenomination:
            'O administrador deve receber a newsletter mensal do ChurchTools com dicas de uso e novidades sobre o software e a empresa.',
        agbs: 'Termos e Condições',
        gdpr: 'informações sobre proteção de dados',
        website: 'Website ou pagina no Facebook',
        currentWebsite: 'Site atual ou site do Facebook',
        username: 'Usuário',
        password: 'Senha',
        login: 'Login de suporte',
        setupService: 'Serviço de configuração',
        setupMeeting: 'Seleção de datas',
        useSetupService: 'Use o serviço de configuração gratuito',
        pleaseSelectDate: 'Favor selecionar uma data:',
        with: 'com',
        churchtoolsWebsite: 'ChurchTools Website',
        registerWebsite: 'Além disso, teste ChurchTools Website gratuitamente',
        alreadyCustomer: 'Sua igreja já está usando ChurchTools?',
        notYetCustomer: 'Sua igreja ainda não é cliente do ChurchTools?',
        niceHeader: 'Que bom que você gostaria de experimentar o ChurchTools!',
        problemHeader: 'Que preocupação ou problema você gostaria de resolver com a ajuda do ChurchTools?',
        problemDescription:
            'Responder a esta pergunta o mais especificamente possível (máx. 250 caracteres). Isto o ajudará a se concentrar ainda mais no que você deseja alcançar nos próximos 30 dias com a instalação experimental do ChurchTools.',
        justLooking: '"Na verdade, eu só quero olhar."',
        justLookingDescription:
            'Neste caso, recomendamos nossa instalação de demonstração, que é perfeita para uma rápida visão geral das muitas funções do ChurchTools. Ela já está preenchida com amostras de dados para que você possa testar todos os módulos sem esforço.',
        justLookingDescription2:
            'Você tem 3 dias completos para explorar a demonstração. Se este tempo não for suficiente, você pode criar uma nova demonstração a qualquer momento.',
        andNowAFewDetails: 'E agora alguns detalhes ...',
        detailsAboutYourChurch: '... sobre sua igreja',
        detailsAboutYou: '... sobre você',
        institutionId: 'Institutions-ID'
    },
    button: {
        register: 'iniciar teste grátis',
        registering: 'Por favor, aguarde...',
        login: 'Login',
        demo: 'Create Demo'
    },
    link: {
        dataprivacy: 'https://www.church.tools/pt/data-security',
        impressum: 'https://www.church.tools/pt/impressum',
        agbs: 'https://church.tools/pt/agb',
        demo: 'https://ccp.church.tools/demo',
        demoXXX: 'https://www.church.tools/de/churchtools-testen?cta=ccp'
    },
    linklabel: {
        dataprivacy: 'Proteção dos dados',
        impressum: 'Informação legal'
    },
    languages: {
        de: 'Alemão',
        en: 'Inglês',
        pt: 'Português'
    },
    language: {
        choose: {
            label: 'Escolha sua língua:'
        }
    },
    hint: {
        instancename: '30 caracteres no máximo, apenas de a-z, 0-9 e - permitidos',
        appellation: 'Título',
        discountcode: 'Para uma posterior licença paga',
        heardfrom: 'Onde você ouviu sobre nós?',
        testChurchTools:
            'Teste a funcionalidade completa do ChurchTools gratuitamente por 30 dias. O período de avaliação termina automaticamente sem a necessidade de cancelamento.',
        testChurchToolsPlusWebsite:
            'Teste a funcionalidade completa do ChurchTools e ChurchTools Website gratuitamente por 30 dias. O período de avaliação termina automaticamente sem a necessidade de cancelamento.',
        testWebsite: '30 dias de teste completo gratuito',
        setupServiceOptional:
            'Estamos felizes em ajudá-lo a começar com o ChurchTools e apoiá-lo com a instalação inicial. Para este fim, oferecemos a você uma reunião Zoom gratuita de 1 hora, na qual também outras pessoas de sua congregação são bem-vindas para participar. Durante a reunião, trabalharemos juntos para fazer os primeiros ajustes para sua nova instalação do ChurchTools, para que você possa então continuar testando de forma otimizada.',
        setupServiceMandatory:
            'Nós o ajudamos nos primeiros passos com ChurchTools e o apoiamos com a configuração inicial. Para este fim, realizaremos uma reunião gratuita de zoom de 1 hora com você, na qual também outras pessoas de sua congregação são bem-vindas para participar. Durante a reunião, trabalharemos juntos para fazer os primeiros ajustes para sua nova instalação do ChurchTools, para que você possa então continuar testando de forma otimizada.',
        churchtoolsWebsite:
            'Com <a href="https://church.tools/website" target="_blank">ChurchTools Website</a> você pode facilmente apresentar sua igreja de sua maneira individual com layouts pré-fabricados. Você pode exibir pessoas, grupos e datas no site com alguns cliques usando o editor e atualizá-los diretamente do ChurchTools.',
        startTestphaseFromChurchTools:
            'Neste caso, a fase de teste do site ChurchTools deve ser iniciada diretamente do ChurchTools. No menu Gerenciar, vá para "Relações Públicas" e depois para "ChurchTools Website".',
        freeCombo:
            'Com ChurchTools Website, sua congregação da igreja também recebe um pacote Combo permanentemente gratuito de <a href="https://church.tools" target="_blank">ChurchTools</a>.',
        institutionId: ''
    },
    appellation: {
        mrs: 'Sra.',
        mr: 'Sr.',
        not_specified: 'não especificado'
    },
    heardfrom: {
        friend: 'de um amigo ou colega',
        church: 'outra igreja',
        google: 'Sites de pesquisa (ex.: Google, Yahoo, etc.)',
        facebook: 'Facebook',
        instagram: 'Instagram',
        capterra: 'Capterra',
        magazine: 'em uma revista',
        conference: 'em uma conferência ou evento',
        other: 'outro'
    },
    buttonorderforfree: 'Teste grátis',
    requiredfield: '* indica um campo obrigatório',
    email: {
        subject: {
            validation: '[ChurchTools] Confirme seu registro',
            welcome: 'Introdução ao ChurchTools + como tirar suas dúvidas',
            day25: 'Seu período teste termina em 5 dias.',
            day30: 'O seu período de teste gratuito do ChurchTools termina hoje',
            day45: 'Uma notícia boa e uma ruim...\n',
            day80: 'Pedimos desculpas por isso...',
            day90: 'Isso é uma despedida?',
            duplicate: '[ChurchTools] Instalação duplicada',
            licenseChange: 'Alterar licença do ChurchTools',
            licenseOrderConfirmation: 'Confirmação do pedido do ChurchTools',
            soondeleteinstance: '[ChurchTools] Sua conta está inativa',
            deleteinstance: '[ChurchTools] Sua conta foi deletada',
            newlicensemodel: 'Notícias importantes do ChurchTools',
            siteCreated: 'Exemplo ChurchTools criado'
        },
        logo: 'https://ccp.church.tools/images/ct-logo-slogan-pt.png'
    },
    header: {
        greeting: 'Olá {appellation} {name}',
        register: 'Solicitar uma instalação gratuita do ChurchTools',
        location: 'Cidade: {location}',
        church: 'Igreja: {church}'
    },
    register: {
        header: 'Teste gratuitamente o ChurchTools por 30 dias',
        headerWebsite: 'Teste Website ChurchTools de graça',
        headerFinder: 'Cadastre gratuitamente ChurchTools para seu perfil de pesquisador',
        headerDenomination: 'Registrar ChurchTools para',
        headerDenominationUpdateAdmin: 'Atualizar ChurchTools admin para',
        headerinstanceavailable:
            '🎉 Parabéns, esse sub-domínio ainda está disponível, aproveite e teste o ChurchTools por 30 dias gratuitamente agora mesmo.',
        finished: {
            description:
                'Para completar o processo, precisamos confirmar seu endereço de e-mail. Acabamos de enviar um e-mail para {email}. Por favor, clique no link dentro do e-mail.',
            descriptionDenomination:
                'A instalação do ChurchTools será agora criada. Demorará alguns minutos.</br></br>Assim que isto estiver terminado, enviaremos um e-mail para</br>{email} (administrator)</br>e</br>{denominationEmail} ({denominationName}).',
            duplicate:
                'Obrigado por se registrar. Nossa equipe de suporte vai cuidar da sua instalação e entrar em contato com você pelo e-mail {email}',
            header: 'Sua instalação do ChurchTools foi solicitada!',
            resend: 'Enviar e-mail novamente',
            editEmail: 'Corrigir endereço de e-mail',
            resendEmail: {
                success: 'O e-mail foi enviado novamente para o seu endereço de e-mail.',
                error: 'O e-mail não pôde ser enviado, tente novamente mais tarde'
            },
            saveEmail: 'salvar',
            changeEmail: {
                success:
                    'O endereço de e-mail foi alterado com sucesso. O e-mail para confirmação do seu endereço de e-mail foi enviado novamente',
                error: 'O endereço de e-mail não pôde ser alterado.'
            },
            status: 'Setup status',
            again: 'Registrar outras instalações'
        }
    },
    setup: {
        status: {
            header: 'Obrigado por validar seu endereço de e-mail!',
            headerDenomination: 'Thank you for the registration!',
            description: 'Aguarde um momento, estamos providenciando a sua instalação do ChurchTools',
            error:
                'Desculpe, ocorreu um erro durante a instalação. Vamos resolvê-lo o mais rápido possível e contatá-lo através do seu endereço de e-mail {email}'
        },
        finished: {
            header: 'A instalação foi concluída',
            description:
                'Agora você pode entrar com seu e-mail {email} e com a senha "admin". Ir para <a href="https://{siteName}.church.tools">{siteName}.church.tools</a>.',
            descriptionWebsite:
                'Agora você pode entrar com os dados de acesso do e-mail de boas-vindas e depois mudar sua senha.',
            login: 'Ir para Login'
        }
    },
    validation: {
        wait: 'Validando {token}, por favor aguarde um instante...',
        email: 'O campo deve conter um e-mail válido.',
        empty: 'O campo não pode ficar em branco.',
        exactlength: 'O campo deve ter um comprimento de {length}.',
        allowed: 'O campo deve conter um dos seguintes valores: {allowed}.',
        length: 'O campo deve ter entre {min} e {max} caracteres.',
        minlength: 'O campo deve ter no mínimo {min} caracteres',
        maxlength: 'O campo pode ter no máximo {max} caracteres',
        sitename: {
            invalidchars: 'O campo contém caracteres inválidos, somente de a-z, 0-9 e - são permitidos.',
            taken: 'O endereço escolhido não está disponível.',
            notYetKnown: 'Este nome do site ainda não é conhecido.'
        },
        errorHeader: 'Erro ao validar e-mail.',
        churchname: 'Por favor, digite o nome completo de sua igreja (pelo menos 5 caracteres).',
        duplicateEmail: 'É permitido apenas uma instalação por igreja.'
    },
    error: {
        fielderrors: 'Existem erros de validação.',
        noresendtoken: 'Parâmetro reenvio de token faltando.',
        notoken: 'Parâmetro token faltando.',
        novalidationtoken: 'Parâmetro validação de token faltando.',
        emailvalidated: 'O e-mail já foi validado.',
        sitenamealreadyprogress: 'Uma instalação com o mesmo nome da pagina já está em andamento.',
        tokeninvalid:
            'O link não está mais válido. Por favor, registre-se novamente ou entre em contato com a nossa equipe de suporte através do e-mail support@churchtools.de',
        licensekeyinvalid: 'A chave de licença não é válida.',
        internal:
            'Infelizmente, ocorreu um erro durante a instalação. Vamos tentar corrigi-lo o mais rápido possível e entrar em contato com você por meio do seu endereço de e-mail {email}'
    },
    countries: {
        '---': '-----',
        AF: 'Afeganistão',
        EG: 'Egito',
        AX: 'Åland Islands',
        AL: 'Albânia',
        DZ: 'Argélia',
        AS: 'Samoa Americana',
        VI: 'Ilhas Virgens, U.s',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antártica',
        AG: 'Antígua e Barbuda',
        GQ: 'Guiné Equatorial',
        AR: 'Argentina',
        AM: 'Armenia',
        AW: 'Aruba',
        AC: 'Ilha da Ascensão',
        AZ: 'Azerbaijão',
        ET: 'Etiópia',
        AU: 'Austrália',
        BS: 'Bahamas',
        BH: 'Bahrein',
        BD: 'Bangladesh',
        BB: 'Barbados',
        BE: 'Bélgica',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BO: 'Bolívia',
        BA: 'Bósnia e Herzegovinaa',
        BW: 'Botswana',
        BV: 'Ilha Bouvet',
        BR: 'Brasil',
        VG: 'Ilhas Virgens Britânicas',
        IO: 'Território do Oceano Índico Britânico',
        BN: 'Brunei Darussalam',
        BG: 'Bulgária',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        CL: 'Chile',
        CN: 'China',
        CK: 'Cook Islands',
        CR: 'Costa Rica',
        DK: 'Dinamarca',
        DE: 'Alemanha',
        SH: 'Santa Helena',
        DG: 'Diego Garcia',
        DM: 'Dominica',
        DO: 'República Dominicana',
        DJ: 'Djibouti',
        EC: 'Equador',
        SV: 'El Salvador',
        ER: 'Eritréia',
        EE: 'Estônia',
        EU: 'União Europeia',
        FK: 'Ilhas Falkland (malvinas)',
        FO: 'Faroe Islands',
        FJ: 'Fiji',
        FI: 'Finlândia',
        FR: 'França',
        GF: 'Guiana Francesa',
        PF: 'Polinésia Francesa',
        TF: 'Territórios Franceses do Sul',
        GA: 'Gabão',
        GM: 'Gambia',
        GE: 'Georgia',
        GH: 'Gana',
        GI: 'Gibraltar',
        GD: 'Grenada',
        GR: 'Grécia',
        GL: 'Groenlândia',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GG: 'Guernsey',
        GN: 'Guiné',
        GW: 'Guiné-Bissau',
        GY: 'Guiana',
        HT: 'Haiti',
        HM: 'Heard Island And Mcdonald Islands',
        HN: 'Honduras',
        HK: 'Hong Kong',
        IN: 'Índia',
        ID: 'Indonésia',
        IQ: 'Iraque',
        IR: 'Irã',
        IE: 'Irlanda',
        IS: 'Islândia',
        IM: 'Isle Of Man',
        IL: 'Israel',
        IT: 'Itália',
        JM: 'Jamaica',
        JP: 'Japão',
        YE: 'Iêmen',
        JE: 'Jersey',
        JO: 'Jordan',
        KY: 'Cayman Islands',
        KH: 'Camboja',
        CM: 'Camarões',
        CA: 'Canadá',
        IC: 'Ilhas Canárias',
        CV: 'Cabo Verde',
        KZ: 'Cazaquistão',
        QA: 'Qatar',
        KE: 'Quênia',
        KG: 'Quirguistão',
        KI: 'Kiribati',
        CC: 'Ilhas Cocos (Keeling)',
        CO: 'Colômbia',
        KM: 'Comoros',
        CD: 'Congo, República Democrática do',
        HR: 'Croacia',
        CU: 'Cuba',
        KW: 'Kuwait',
        LA: 'República Democrática Popular do Lao',
        LS: 'Lesotho',
        LV: 'Letônia',
        LB: 'Líbano',
        LR: 'Liberia',
        LY: 'Líbia',
        LI: 'Liechtenstein',
        LT: 'Lituânia',
        LU: 'Luxemburgo',
        MO: 'Macao',
        MG: 'Madagascar',
        MW: 'Malawi',
        MY: 'Malásia',
        MV: 'Maldivas',
        ML: 'Mali',
        MT: 'Malta',
        MA: 'Morrocos',
        MH: 'Marshall Islands',
        MQ: 'Martinica',
        MR: 'Mauritânia',
        MU: 'Maurício',
        YT: 'Mayotte',
        MK: 'República da Macedónia',
        MX: 'México',
        FM: 'Micronésia, Estados Federados de',
        MD: 'Moldova',
        MC: 'Monaco',
        MN: 'Mongólia',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MZ: 'Moçambique',
        MM: 'Burma',
        NA: 'Namíbia',
        NR: 'Nauru',
        NP: 'Nepal',
        NC: 'Nova Caledônia',
        NZ: 'Nova Zelândia',
        NT: 'zona neutra saudita-iraquiana',
        NI: 'Nicarágua',
        NL: 'Holanda/Paises Baixos',
        AN: 'Antilhas Holandesas',
        NE: 'Níger',
        NG: 'Nigéria',
        NU: 'Niue',
        KP: 'Coréia do Norte',
        MP: 'Northern Mariana Islands',
        NF: 'Ilha de Norfolk',
        NO: 'Noruega',
        OM: 'Omã',
        AT: 'Áustria',
        TL: 'Timor Leste',
        PK: 'Paquistão',
        PS: 'Território palestino, ocupado',
        PW: 'Palau',
        PA: 'Panamá',
        PG: 'Papua Nova Guiné',
        PY: 'Paraguai',
        PE: 'Peru',
        PH: 'Filipinas',
        PN: 'Pitcairn',
        PL: 'Polônia',
        PT: 'Portugal',
        PR: 'Porto Rico',
        CI: 'Costa do Marfim',
        CG: 'Congo',
        RE: 'RÉunion',
        RW: 'Ruanda',
        RO: 'Roménia',
        RU: 'Rússia',
        SB: 'Ilhas Salomão',
        ZM: 'Zâmbia',
        WS: 'Samoa',
        SM: 'San Marino',
        ST: 'São Tomé e Príncipe',
        SA: 'Arábia Saudita',
        SE: 'Suécia',
        CH: 'Suíça',
        SN: 'Senegal',
        RS: 'Sérvia',
        CS: 'Sérvia e Montenegro',
        SC: 'Seychelles',
        SL: 'Serra Leoa',
        ZW: 'Zimbabué',
        SG: 'Singapura',
        SK: 'Eslováquia',
        SI: 'Eslovénia',
        SO: 'Somália',
        SU: 'União Soviética',
        ES: 'Espanha',
        LK: 'Sri Lanka',
        KN: 'São Cristóvão e Nevis',
        LC: 'Santa Lúcia',
        PM: 'São Pedro e Miquelon',
        VC: 'São Vicente e Granadina',
        ZA: 'Africa do Sul',
        SD: 'Sudão',
        GS: 'Geórgia do Sul e Ilhas Sandwich do Sul',
        KR: 'Coréia do Sul',
        SR: 'Suriname',
        SJ: 'Svalbard And Jan Mayen',
        SZ: 'Suazilândia',
        SY: 'República Árabe da Síria',
        TJ: 'Tajiquistão',
        TW: 'Taiwan',
        TZ: 'Tanzânia, República Unida de',
        TH: 'Tailândia',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad And Tobago',
        TA: 'Tristan da Cunha',
        TD: 'Chad',
        CZ: 'República Checa',
        TN: 'Tunísia',
        TR: 'Turquia',
        TM: 'Turkmenistan',
        TC: 'Ilhas Turcas e Caicos',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ucrânia',
        HU: 'Hungria',
        UY: 'Uruguai',
        UZ: 'Uzbequistão',
        VU: 'Vanuatu',
        VA: 'Cidade do Vaticano',
        VE: 'Venezuela',
        AE: 'Emirados Árabes Unidos',
        US: 'Estados Unidos da América',
        GB: 'Reino Unido',
        VN: 'Vietnã',
        WF: 'Wallis And Futuna',
        CX: 'Christmas Island',
        BY: 'Bielorrussia',
        EH: 'Western Sahara',
        CF: 'República Centro-Africana',
        CY: 'Chipre',
        BQ: 'Bonaire',
        BL: 'Saint-Barthélemy',
        MF: 'Saint Martin',
        KO: 'Kosovo',
        SS: 'South Sudan',
        CW: 'Curacao',
        SX: 'Sint Maarten',
        UM: 'United States Minor Outlying Islands'
    },
    support: {
        dashboard: {
            tabs: {
                errors: 'Errors',
                pendings: 'Pending',
                duplicates: 'Duplicates',
                inprogress: 'in Progress',
                finished: 'Done',
                usage: 'Usage'
            },
            searchButton: 'search',
            instancename: 'Instance name'
        },
        table: {
            updated: 'Updated',
            product: 'Product',
            sitename: 'Sitename',
            churchname: 'Church name',
            username: 'Person name',
            email: 'E-Mail',
            baselanguage: 'Base language',
            cta: 'Call to Action',
            status: 'Status'
        },
        registrationDetails: {
            header: 'Registration Information',
            contactData: 'Contact',
            churchData: 'Church',
            isDuplicate: 'Is Duplicate',
            sendNotice: 'Send notice',
            noDuplicate: 'No Duplicate',
            name: 'Name:',
            email: 'Email:',
            phone: 'Phone:',
            registerLanguage: 'Registration language:',
            churchName: 'Churchname:',
            city: 'City:',
            country: 'Country:',
            baseLanguage: 'Language:',
            instanceName: 'Instance Name:',
            website: 'Website:',
            furtherInformation: 'Further Informations',
            heardFrom: 'Heard from:',
            discount: 'Discount:',
            license: 'License:',
            created: 'created:',
            userAgent: 'Browser:',
            logs: 'Logs',
            comment: 'Komentar',
            cta: 'Call to action:',
            linkfreescout: 'Find in FreeScout',
            addcomment: 'Add comment',
            proceedinstallation: 'Proceed installation',
            lastupdate: 'Updated:',
            markdone: 'Mark as done',
            infomails: 'Infomails:',
            newsletter: 'Newsletter:'
        },
        usageDetails: {
            header: 'Usage details',
            usageLicenseData: 'license-relevant usage data',
            persons: 'Persons',
            services: 'Services',
            resources: 'Resources',
            calendars: 'Calendars',
            stations: 'Campuses',
            usageDataLast30Days: 'New entries within the last 30 days',
            persons30: 'Persons',
            personsActive30Days: 'Persons logged in',
            groups30: 'Groups',
            csEntries30: 'Service assignments',
            crEntries30: 'Resource bookings',
            calEntries30: 'Calendar entries',
            licenseOverUnder: 'Over-/Under-licensing',
            overLicensed: 'over-licensed',
            underLicensed: 'under-licensed'
        },
        setupState: {
            duplicate: 'Duplicate',
            possibleduplicate: 'possible Duplicate',
            error: 'Error',
            pending: 'Waiting for email validation',
            done: 'Done',
            inprogress: 'In Progress',
            manuelDone: 'marked as done'
        },
        registrationOverview: {
            noDataFound: 'No entries available'
        },
        duplicates: {
            header: 'Possible Duplicate',
            intern: 'INTERN',
            ccp: 'CCP',
            tableColumn: {
                type: 'TYPE',
                churchName: 'Churchname',
                email: 'E-Mail',
                phone: 'Phone',
                city: 'City',
                country: 'Country',
                website: 'Website',
                setupState: 'Setup State'
            }
        },
        login: {
            error: 'O nome de usuário ou senha está errado.'
        }
    },
    license: {
        tax: {
            nStb: 'Montante não tributável.',
            nStbUstID: 'Os impostos para este serviço tributável são devidos pelo destinatário. O seu CNPJ é: {ust id}',
            MwSt: '19% em impostos.'
        },
        discount: {
            discountAmountOnSum: '{amount} do total{comment}',
            discountAmountOnPart: '{amount} de {part}{comment}',
            discountPercentOnSum: '{percent}% do total{comment}',
            discountPercentOnPart: '{percent}% from {part}{comment}',
            fixPriceForSum: 'Preço total fixado{comment}',
            fixPriceForPart: 'Preço total fixado para {part}{comment}',
            minPriceForSum: 'Adicional ao preço total mínimo negociado de {price}{comment}',
            minPriceForPart: 'Adicional ao preço total mínimo negociado de {price} para {part}{comment}'
        },
        yes: 'sim',
        no: 'nao',
        dateformat: 'DD/MM/YY',
        unlimited: 'ilimitado',
        financeClients: 'Clientes',
        syncConnections: 'Conexões de sincronização'
    },
    demo: {
        header: 'ChurchTools Demo',
        information: {
            header: 'Informações sobre a demo',
            text:
                'A Instalação Demo do ChurchTools é preenchida com amostras de dados para explorar o ChurchTools. Esta instalação é gratuita e será automaticamente apagada após 3 dias.'
        },
        support: {
            text: 'Se você tiver alguma dúvida, por favor entre em contato com nossa equipe de suporte.',
            contact: 'Contate a equipe de suporte'
        },
        create: {
            button: 'Criar demo',
            spinner: 'Nós criaremos uma nova demonstração para você. Isto pode levar até um minuto.'
        },
        churchtools: {
            button: 'Acesso ChurchTools',
            text: 'Sua demo foi criada'
        },
        error: {
            header: 'Algo deu errado',
            text:
                'Devemos ter cometido um erro. Infelizmente, nenhuma instalação de demonstração do ChurchTools pôde ser criada. Por favor, atualize a página e tente novamente. Se o problema persistir, entre em contato com nosso suporte, nossa equipe de suporte ficará feliz em ajudá-lo.',
            reload: 'Atualizar'
        },
        template: {
            label: 'Escolha o tipo de demonstração:',
            freikirche: 'Denominações Protestantes variadas',
            evangelisch: 'Igreja Evangélica',
            katholisch: 'Igreja Católica',
            cvjm: 'CVJM'
        }
    }
};
